
/**
 * Represents the result of a heat map calculation, including foreground and background colors.
 */
export class HotHeatMapResult {

  /**
   * The foreground color for the heat map cell.
   */
  public colorHm: string | null = '#000000';

  /**
   * The background color for the heat map cell.
   */
  public colorHmBg: string | null = '#ffffff';
}


